import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import InlineSVG from 'react-inlinesvg';
import styles from './styles.module.scss';

function SVG({ muted, secondary, icon, styles: customStyles, ...props }) {
  if (process.env.NODE_ENV === 'test') {
    return (
      <span {...props}>
        <span>Inline SVG goes here</span>
      </span>
    );
  }

  return (
    <span
      className={classnames([
        styles.svg,
        { [styles.muted]: muted },
        { [styles.secondary]: secondary },
        ...customStyles
      ])}
      {...props}>
      <InlineSVG src={`/assets/icons/${icon}.svg`} {...props} />
    </span>
  );
}

SVG.propTypes = {
  muted: PropTypes.bool,
  secondary: PropTypes.bool,
  styles: PropTypes.array,
  icon: PropTypes.string.isRequired
};

SVG.defaultProps = {
  muted: false,
  secondary: false,
  styles: []
};

export default SVG;
